import { useState, useEffect } from 'react'

import usePCWindow from './usePCWindow'

import { ScreenSize } from '../constants/media-constanst'
import { Events } from 'constants/events'

const SIDE_PADDING = 40
// const CARD_MARGIN = 24
const MAX_CONTAINER = 1110
const CARD_WIDTH = 350

const useCardWidth = () => {
  const [cardWidth, setCardWidth] = useState(0)
  const isPC = usePCWindow(ScreenSize.big)

  const handleResize = () => {
    const calcCardSize =
      window.innerWidth - SIDE_PADDING > MAX_CONTAINER ? CARD_WIDTH : CARD_WIDTH - SIDE_PADDING

    setCardWidth(calcCardSize)
  }

  useEffect(() => {
    if (isPC) {
      window.addEventListener(Events.RESIZE, handleResize)
      handleResize()
    } else setCardWidth(0)

    return () => window.removeEventListener(Events.RESIZE, handleResize)
  }, [isPC])

  return cardWidth ? { width: cardWidth } : {}
}

export default useCardWidth
